export default {
  getItem(key) {
    const sessionStorage = window.sessionStorage.getItem(key);
    return JSON.parse(sessionStorage);
  },
  setItem(key, item) {
    window.sessionStorage.setItem(key, JSON.stringify(item));
  },
  getSistema() {
    return window.sessionStorage.getItem('SISTEMA');
  },
  removeItem(key) {
    return window.sessionStorage.removeItem(key);
  },
  updateItem(key, item) {
    window.sessionStorage.removeItem(key);
    window.sessionStorage.setItem(key, JSON.stringify(item));
  },
};
